import { render } from "./TabBlock.vue?vue&type=template&id=419f7782&scoped=true"
import script from "./TabBlock.vue?vue&type=script&lang=js"
export * from "./TabBlock.vue?vue&type=script&lang=js"

import "./TabBlock.vue?vue&type=style&index=0&id=419f7782&lang=scss&scoped=true"

import exportComponent from "/var/www/sanremo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-419f7782"]])

export default __exports__